/**
 * @fileoverview Singer Song Card component.
 * @summary Displays a single song card from singer's history.
 *
 * @package KaraoNow
 * @module apps/front/src/pages/singer/components/SingerSongCard
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { useTranslation } from 'react-i18next'

interface SingerSong {
  id: string
  title: string
  artist: string
  eventName: string
  organizerName: string
  addedAt: string
  eventDate?: string
}

interface SingerSongCardProps {
  song: SingerSong
  formatDate: (dateString: string) => string
}

/**
 * @summary Singer song card component.
 * @param {SingerSongCardProps} props - Component props.
 * @returns {React.ReactElement} Song card.
 */
export function SingerSongCard({
  song,
  formatDate,
}: SingerSongCardProps) {
  const { t } = useTranslation()

  return (
    <div className="card bg-base-100 dark:bg-base-800 shadow-sm hover:shadow-md transition-shadow">
      <div className="card-body p-4 sm:p-6">
        <h3 className="card-title text-lg sm:text-base mb-1">{song.title}</h3>
        <p className="text-sm text-base-600 dark:text-base-400 mb-3">{song.artist}</p>
        <div className="space-y-1 text-sm text-base-600 dark:text-base-400">
          <p>
            {t('singer.event')}: <span className="font-medium text-base-900 dark:text-base-100">{song.eventName}</span>
          </p>
          <p>
            {t('singer.date')}: <span className="font-medium text-base-900 dark:text-base-100">{song.eventDate ? formatDate(song.eventDate) : 'N/A'}</span>
          </p>
        </div>
      </div>
    </div>
  )
}

